// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowProgramActionsMenu = ({
  row,
  onDelete,
  onEdit,
  onCreateProgramBranch,
  onViewProgramBranches,
  hasPermissionDirect,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_program_active == 0;

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onEdit(row);
            handleClose();
          }}
        >
          Edit Program
        </MenuItem>

        <MenuItem
          onClick={() => {
            onDelete(row);
            handleClose();
          }}
        >
          Delete Program
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateProgramBranch(row.program_id, row.college_id, row.program_name);
            handleClose();
          }}
        >
          Create Branch
        </MenuItem>

        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewProgramBranches(row.program_id, row.college_id, row.program_name);
            handleClose();
          }}
        >
          View Branches
        </MenuItem>
      </Menu>
    </>
  );
};
RowProgramActionsMenu.propTypes = {
  row: PropTypes.shape({
    college_id: PropTypes.number.isRequired,
    program_id: PropTypes.number.isRequired,
    program_desc: PropTypes.string.isRequired,
    program_name: PropTypes.string.isRequired,
    is_program_active: PropTypes.number.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCreateProgramBranch: PropTypes.func.isRequired,
  onViewProgramBranches: PropTypes.func.isRequired,
  hasPermissionDirect: PropTypes.func.isRequired,
};
export default RowProgramActionsMenu;
